import {
  Archive,
  CheckCircle2,
  Clock3,
  FilePenLine,
  FileText,
  FileX,
} from "lucide-react";

export const ALL_YEARS = "all";
export const ALL_STATUSES = "all";

export const BUDGET_VIEW_TYPES = {
  CARD: "card",
  LIST: "list",
};

export const status: any = {
  draft: "Draft",
  approved: "Approved",
  pending_approval: "Pending Approval",
  pending: "Pending Approval",
  archived: "Archived",
  rejected: "Rejected",
};

export const statusColor: any = {
  card: {
    draft: "border-l-amber-400",
    approved: "border-l-green-500",
    pending_approval: "border-l-amber-400",
    pending: "border-l-amber-400",
    archived: "border-l-red-500",
    rejected: "border-l-red-500",
    default: "border-l-primary",
  },
  icon: {
    draft: "bg-amber-100 text-amber-500",
    approved: "bg-green-100 text-green-600",
    pending_approval: "bg-amber-100 text-amber-500",
    pending: "bg-amber-100 text-amber-500",
    archived: "bg-red-100 text-red-500",
    rejected: "bg-red-100 text-red-500",
    default: "bg-blue-100 text-primary",
  },
  badge: {
    draft: "border-yellow-600 bg-yellow-100 text-yellow-600",
    approved: "border-green-600 bg-green-100 text-green-600",
    pending_approval: "border-red-600 bg-red-100 text-red-600",
    pending: "border-red-600 bg-red-100 text-red-600",
    archived: "border-red-600 bg-red-100 text-red-600",
    rejected: "border-red-600 bg-red-100 text-red-600",
    default: "border-blue-300 bg-blue-50 text-primary",
  },
  value: {
    draft: "text-amber-600",
    approved: "text-green-600",
    pending_approval: "text-primary",
    pending: "text-primary",
    archived: "text-red-600",
    rejected: "text-red-600",
    default: "text-primary",
  },
};

export const statusIcon: any = {
  draft: FilePenLine,
  approved: CheckCircle2,
  pending_approval: Clock3,
  pending: Clock3,
  archived: Archive,
  rejected: FileX,
  default: FileText,
};

export const budgetSummaryConfig = [
  {
    key: "approved",
    title: "Approved",
    caption: "Budget",
    icon: CheckCircle2,
  },
  {
    key: "pending_approval",
    title: "Pending Approval",
    caption: "Budgets",
    icon: Clock3,
  },
  {
    key: "draft",
    title: "Draft",
    caption: "Budgets",
    icon: FilePenLine,
  },
  {
    key: "archived",
    title: "Archived",
    caption: "Budgets",
    icon: Archive,
  },
  {
    key: "rejected",
    title: "Rejected",
    caption: "Budgets",
    icon: FileX,
  },
];

export const budgetStatusOptions = [
  { label: "All Status", value: ALL_STATUSES },
  { label: "Approved", value: "approved" },
  { label: "Pending Approval", value: "pending_approval" },
  { label: "Draft", value: "draft" },
  { label: "Archived", value: "archived" },
  { label: "Rejected", value: "rejected" },
];

export const getBudgetStatusKey = (status = "") =>
  status?.toString()?.trim()?.toLowerCase()?.replace(/\s+/g, "_");

export const getBudgetStatusGroup = (status = "") => {
  const statusKey = getBudgetStatusKey(status);

  if (statusKey == "pending") {
    return "pending_approval";
  }

  return statusKey;
};
